import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Wrap = styled.div`
  position: relative;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.bgDarker};
  padding: 0.9rem 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
`;

const Track = styled.div`
  display: flex;
  width: max-content;
  animation: ${scroll} ${({ $duration }) => $duration}s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation-play-state: paused;
  }
`;

const Item = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0 1.4rem;
  white-space: nowrap;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  color: #f4f3ee;

  &::after {
    content: '✦';
    color: ${({ theme }) => theme.colors.gold};
    font-size: 0.7rem;
  }
`;

/** Ticker infinito. `items` es un array de strings cortos. */
function Marquee({ items, duration = 26 }) {
  const doubled = [...items, ...items];

  return (
    <Wrap role="presentation" aria-hidden="true">
      <Track $duration={duration}>
        {doubled.map((text, i) => (
          <Item key={i}>{text}</Item>
        ))}
      </Track>
    </Wrap>
  );
}

export default Marquee;
